import React, { useState, useEffect } from "react";
import "./BlinkingNode.css";
import styled from "styled-components";
const BlinkWrapper = styled.div`
  @media (min-width: 380px) and (max-width: 770px) {
    margin-top: 4rem;
  }

  @media (max-width: 379px) {
    margin-top: 5rem;
  }
`;

const BlinkingNode = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Toggle visibility every 1 second
    const interval = setInterval(() => {
      setIsVisible((prevVisible) => !prevVisible);
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <BlinkWrapper isVisible={isVisible ? "blink" : ""}>{children}</BlinkWrapper>
  );
};

export default BlinkingNode;
